<script>
// CommitChart.js
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.options)
  }  
  // mounted () {
  //   // Overwriting base render method with actual data.
  //   this.renderChart({
  //     labels: ['Barriers', 'Strengths', 'Ideas'],
  //     datasets: [
  //       {
  //         label: 'GitHub Commits',
  //         backgroundColor: ['red', 'blue', 'orange'],
  //         data: [40, 20, 12]
  //       }
  //     ]
  //   })
  // }
}
</script>
